module.exports = __webpack_public_path__ + "static/media/clave_unica.ffa4cc81.svg";